export default __webpack_public_path__ + "static/media/portfolio.d62d5b04.png";